import React from 'react';
import type { MapEmbedConfig } from './types';
import { getMapEmbedUrl } from './embedUtils';

interface MapEmbedProps {
  config: MapEmbedConfig;
  lazyLoad?: boolean;
}

export const MapEmbed: React.FC<MapEmbedProps> = ({ config, lazyLoad }) => {
  const mapUrl = getMapEmbedUrl(config);
  if (!mapUrl) return null;

  return (
    <iframe
      src={mapUrl}
      width={config.width || '100%'}
      height={config.height || '450'}
      style={{ border: 0 }}
      allowFullScreen
      loading={lazyLoad ? 'lazy' : undefined}
      referrerPolicy="no-referrer-when-downgrade"
      title="Embedded map"
    />
  );
};
